import { PROFILES_LIST_ACTION, ADD_PROFILE_ACTION, UPDATE_PROFILE_ACTION } from "../Actions/ProfileListAction";

const initialstate = { profilesList: [] };

const profilesListReducer = (state = initialstate, action) => {
    switch (action.type) {
        case PROFILES_LIST_ACTION:
            return {
                ...state,
                profilesList: action.payload,
            };
        case ADD_PROFILE_ACTION:
            return {
                ...state,
                profilesList: [...state.profilesList, action.payload],  
            };
        case UPDATE_PROFILE_ACTION:
            return {
                ...state,
                profilesList: state.profilesList.map(profile =>
                    profile.id === action.payload.id
                        ? { ...action.payload } 
                        : profile
                ),
            };


        default:
            return state
    }
}


export default profilesListReducer;


